import { connect } from 'react-redux';
import PageWrapper from './pageWrapper';
import { doLogout } from '../../store/user/actions';

const mapDispatchToProps = {
  doLogout,
};

export default connect(null, mapDispatchToProps)(PageWrapper);
